import { Button, Typography } from '@braskai/ui-kit';

import { Box, CardMedia, Stack, StackProps } from '@mui/material';

import Image from '@/shared/assets/images/error-page.png';

export const SomethingWrongError = (props: StackProps) => {
  const handleRefreshPageClick = () => window.location.reload();

  return (
    <Stack alignItems="center" gap={20} justifyContent="center" maxWidth={300} minWidth="100%" {...props}>
      <CardMedia
        sx={{
          height: 133,
          width: 230,
        }}
        alt="Something went wrong"
        component="img"
        src={Image}
      />
      <Stack gap={4} textAlign="center">
        <Typography color="grey.900" variant="title-3-md">
          Something went wrong
        </Typography>
        <Typography color="grey.500" variant="body-1">
          We are already working to fix this.
          <br />
          Please refresh the page or try again later.
        </Typography>
      </Stack>
      <Box>
        <Button data-testid="something-wrong-error-refresh-page" size="lg" onClick={handleRefreshPageClick}>
          Refresh page
        </Button>
      </Box>
    </Stack>
  );
};
